import {Box, Container, AppBar} from '@mui/material'
import Toolbar from '@mui/material/Toolbar'
import {Typography} from '@mui/material'
import ButtonBase from '@mui/material/ButtonBase'
import {styled} from '@mui/material/styles'

export function NavBar() {
	const StyledAppBar = styled(AppBar)({
		backgroundColor: 'black',
		marginBottom: '10px',
	})
	return (
		<>
			<StyledAppBar position="static">
				<Container maxWidth="lg">
					<Toolbar disableGutters>
						<ButtonBase
							component="a"
							href="https://teachforindia.org/volunteer"
						>
							<Box
								sx={{
									height: '56px',
									padding: ' 0px 30px 0px 0px',
								}}
								component="img"
								src="/TFIlogo.png"
							></Box>
						</ButtonBase>
					</Toolbar>
				</Container>
			</StyledAppBar>
			<Container
				sx={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
				}}
				maxWidth="lg"
			>
				<Toolbar disableGutters>
					<ButtonBase
						component="a"
						href="https://teachforindia.org/volunteer"
					>
						<Box
							sx={{height: '130px', padding: 0}}
							component="img"
							src="/logo.png"
						/>
					</ButtonBase>
				</Toolbar>
			</Container>
		</>
	)
}

function Header() {
	const showDowntime = process.env.REACT_APP_DOWNTIME
	return (
		<>
			<NavBar />
			{!showDowntime && (
				<Container
					sx={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						paddingY: 4,
					}}
					maxWidth="lg"
				>
					<Box
						sx={{
							backgroundColor: '#f5f5f5',
							padding: '30px',
							borderRadius: '12px',
							boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
							maxWidth: {xs: '100%', md: '85%'},
							textAlign: 'center',
						}}
					>
						<Typography
							variant="h5"
							sx={{
								fontWeight: 'bold',
								color: '#089eb6',
								marginBottom: '12px',
							}}
						>
							Discover Your Ideal Internship Opportunity!
						</Typography>

						<Box
							component="ol"
							sx={{
								listStyleType: 'upper-alpha',
								color: '#333',
								textAlign: 'left',
								paddingLeft: '20px',
								fontSize: '1rem',
								lineHeight: '20px',
								'& li': {
									marginBottom: '8px',
								},
							}}
						>
							Please review the options listed below and select
							the location and time that align most closely with
							your availability and interests.
						</Box>
					</Box>
				</Container>
			)}
			{showDowntime && (
				<Container
					sx={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						paddingY: 4,
					}}
					maxWidth="lg"
				>
					<Box
						sx={{
							backgroundColor: '#f5f5f5',
							padding: '30px',
							borderRadius: '12px',
							boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
							maxWidth: {xs: '100%', md: '75%'},
							textAlign: 'center',
						}}
					>
						<Typography
							variant="h5"
							sx={{
								fontWeight: 'bold',
								color: '#089eb6',
								marginBottom: '12px',
							}}
						>
							Scheduled Maintenance in Progress: Services Will
							Resume by {showDowntime}
						</Typography>
						<Typography
							variant="body1"
							sx={{
								color: '#333',
								fontSize: '1rem',
								lineHeight: 1.6,
							}}
						>
							Our services are currently undergoing scheduled
							maintenance. We expect to be back online by{' '}
							{showDowntime}. Thank you for your patience and
							understanding!
						</Typography>
					</Box>
				</Container>
			)}
		</>
	)
}
export default Header
